/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import * as React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { TypescriptComponent } from 'components/typescriptExample'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'
import { hot } from 'react-hot-loader'
import { Waypoint } from 'react-waypoint'

const ARTICLE_ID = '22387692'
const ADDITIONAL_SHARES = 173

export class AppComponent extends React.Component<Props> {
  constructor(props) {
    super(props)
    this.isMobile = window.innerWidth < 600
    this.isTable = window.innerWidth < 1025
  }

  render() {
    return (
      <div className='index'>
        <Masthead articleId={ARTICLE_ID} additionalShares={ADDITIONAL_SHARES} />
        <ThemeSwitch />

        {/* TODO Replace the following segment with your project cover */}
        <header className='ui vertical fitted segment'>
          <div className='ui container'>
            <h1 className='ui header' style={{ marginBottom: 0 }}>
              Wo die Einkommen am stärksten steigen – und wo gar nicht
            </h1>
            <h2 className='ui header' style={{ marginTop: 0 }}>
              <div className='small sub header'>
                Die Kluft zwischen Spitzen- und Wenigverdienern wächst. In
                Freienbach haben sich die Einkommen innert 20 Jahren mehr als
                verdoppelt, anderswo sind sie gar gesunken.
              </div>
            </h2>
            <p className='ta author'>
              <strong>Iwan Städler und Patrick Vögeli</strong>
            </p>
          </div>
        </header>

        {/* TODO And probably remove the following segment and replace it with
       your own content */}
        <div className='ui vertical segment'>
          <div className='ui text container'>
            <p>
              Von 63&nbsp;000 auf 158&nbsp;000&nbsp;Franken: So imposant ist das
              durchschnittliche Einkommen in Freienbach SZ innert 20 Jahren
              gestiegen. Keine andere grössere Gemeinde hat auch nur annähernd
              einen derartigen Aufschwung erlebt, wie ein Langzeitvergleich der
              steuerbaren Jahreseinkommen zeigt. Dies hat in der Gemeinde am
              linken Zürichseeufer Spuren hinterlassen. Erfreuliche und weniger
              erfreuliche.
            </p>
            <div className='iframeContainer'>
              <AutofitIFrame
                title='Freienbach legt am meisten zu, in Schaffhausen und Wil geht das Einkommen leicht zurück'
                aria-label='line chart'
                src='//datawrapper.dwcdn.net/td65d/21/'
              />
              {/* <div className='graphicNotation mobile hidden'>Hinweis: Sie können die Liste nach allen Kriterien sortieren.</div> */}
            </div>

            <Waypoint
              scrollableAncestor={window}
              onEnter={event => {
                if (event.previousPosition === Waypoint.below) {
                  window.dataLayer = window.dataLayer || []
                  window.dataLayer.push({
                    event: 'Interactions',
                    // eslint-disable-next-line
                    event_action: 'vertical-scroll',
                    // eslint-disable-next-line
                    event_label: '20ContentRead'
                  })
                }
              }}
            />

            <p>
              Ein Grossteil der Freienbacher Dynamik ist wohl auf reiche
              Neuzuzüger zurückzuführen, welche die dortigen tiefen Steuern zu
              schätzen wissen. Aber auch Alteingesessene hätten womöglich besser
              geschäftet, sagt Gemeindepräsident Daniel Landolt. Die Nachfrage
              der Reichen hat dabei bestimmt nicht geschadet.
            </p>
            <p>
              Bloss: In der Gemeinde, zu der auch Pfäffikon, Wilen, Bäch und
              Hurden gehören, sind nicht nur die Einkommen gestiegen. In die
              Höhe schossen auch die Mieten und Liegenschaftspreise. Viele
              Junge, die in Freienbach aufwachsen, finden keine bezahlbare
              Wohnung mehr, wenn sie bei den Eltern ausziehen. «Ich hatte Glück
              und konnte von meinem Vater eine Liegenschaft übernehmen», sagt
              Landolt. Aber nicht alle hätten dieses Glück. Kollegen von ihm
              flüchteten nach Einsiedeln, Richterswil oder in die March, wo die
              Mieten noch bezahlbar sind – zum Teil aber ebenfalls anziehen. Der
              Gemeindepräsident kennt auch Eltern, die ihre Wohnung den Kindern
              überlassen und ihrerseits wegziehen.
            </p>
            <p>
              «Dieses Problem zu lösen», sagt Landolt, «ist extrem schwierig,
              wenn man eine liberale Haltung hat.» Und eine solche hat der
              CVP-Politiker. Trotzdem möchte die Gemeinde günstigen Wohnraum
              fördern. Sie gewährt daher derartigen Projekten neuerdings eine
              höhere Ausnützung. Geld dafür sprechen mag Freienbach jedoch
              nicht. Man leistet sich auch keine Mehrzweckhalle oder ähnliche
              Annehmlichkeiten. Lieber hält man die Steuern tief.
            </p>
          </div>
          <div
            className='ui text container'
            style={{ marginTop: '1rem', marginBottom: '1rem' }}
          >
            <img
              className='ui fluid image'
              src={require('./imgs/image-freienbach.jpg')}
            />
            <div className='ta secondary caption'>
              Aufgrund der vielen Neuzuzüger muss in Freienbach verdichtet
              werden. Das gefällt nicht allen. Foto: Alessandro Della Bella
            </div>
          </div>

          <div className='ui text container'>
            <p>
              Der einzige «Luxus», den sich Freienbach laut dem
              Gemeindepräsidenten leistet, sind die zahlreichen Schulhäuser –
              verstreut über die verschiedenen Dörfer. Hinzu kommen diverse
              Privatschulen. Jedes fünfte Kind in Freienbach zieht eine solche
              der öffentlichen Schule vor.
            </p>
            <p>
              Mit dem Verdrängen von Alteingesessenen durch reiche Neuzuzüger
              hat sich auch das Zusammenleben in Freienbach verändert. Den
              Vereinen mangelt es an Nachwuchs. Viele Beizen mussten schliessen.
              Und es wird zunehmend verdichtet. Das gefällt nicht allen, gehört
              aber wohl zum ökonomischen Erfolg.
            </p>
            <h2>Wil und Schaffhausen verlieren</h2>
            <p>
              Stark gestiegen sind die Einkommen auch in Zug (74%) und Nyon
              (55%). Zürich (29%), Basel (23%) und Bern (19%) liegen im
              Mittelfeld. Dies lässt sich anhand der jährlichen Statistik der
              Eidgenössischen Steuerverwaltung berechnen. Weil das Bereinigen
              der Steuerveranlagungen bekanntlich seine Zeit braucht, beziehen
              sich die aktuellsten Daten aufs Jahr 2016. Wir haben sie mit jenen
              von 1996 verglichen und konzentrieren uns auf die grösseren
              Gemeinden mit mehr als 10&nbsp;000 Steuerpflichtigen.
            </p>
            <Waypoint
              scrollableAncestor={window}
              onEnter={event => {
                if (event.previousPosition === Waypoint.below) {
                  window.dataLayer = window.dataLayer || []
                  window.dataLayer.push({
                    event: 'Interactions',
                    // eslint-disable-next-line
                    event_action: 'vertical-scroll',
                    // eslint-disable-next-line
                    event_label: '50ContentRead'
                  })
                }
              }}
            />
            <p>
              In zwei Städten – Wil SG und Schaffhausen – ist das
              durchschnittliche Einkommen in den zwanzig Jahren leicht gesunken.
              Beide fielen dadurch unter das landesweite Mittel, das sich 2016
              auf 60&nbsp;000 Franken belief. Der Schaffhauser Stadtrat Daniel
              Preisig führt das Absacken seiner Stadt auf die
              Deindustrialisierung um die Jahrtausendwende zurück. Diese traf
              etwa Georg Fischer hart. Seither steigen die Schaffhauser
              Einkommen wieder leicht.
            </p>
            <h2>Ein Mann, ein Dorf</h2>
            <p>
              Betrachtet man auch kleinere und Kleinst-Gemeinden, verzeichnet
              Vaux-sur-Morges das höchste Durchschnittseinkommen:
              schwindelerregende 760&nbsp;000 Franken. Dies hat die Waadtländer
              Gemeinde einer einzigen Person zu verdanken: André Hoffmann,
              Vizepräsident des Pharmakonzerns Roche. Alle anderen in
              Vaux-sur-Morges verdienen markant weniger. Das zeigt der
              sogenannte Median – jener mittlere Wert, bei dem die Hälfte aller
              Steuerpflichtigen darüber liegt und die andere Hälfte darunter.
            </p>
            <p>
              In Vaux-sur-Morges beträgt der Median 61&nbsp;000&nbsp;Franken.
              Das ist im Vergleich mit anderen Gemeinden immer noch ein stolzer
              Wert. Doch Freienbach und Zug liegen mit 66&nbsp;000 respektive
              63&nbsp;000&nbsp;Franken höher. Am anderen Ende der Skala
              figuriert Locarno mit lediglich 34&nbsp;000&nbsp;Franken.
            </p>
            <h2>Spitzenverdiener ziehen davon</h2>
            <p className='mobile only' style={{ marginBottom: '2rem' }}>
              Frappant ist die Entwicklung der verschiedenen Einkommensklassen,
              die zunehmend auseinanderklaffen. So konnte das bestverdienende
              Tausendstel innert zwanzig Jahren um 53&nbsp;Prozent zulegen – von
              mindestens 690&nbsp;000 auf mindestens 1,05 Millionen Franken. Im
              Kanton Schwyz haben sich diese Einkommen gar mehr als verdreifacht
              (auf mehr als 3,4 Millionen Franken).
            </p>
            <p className='graphicTitle mobile only'>
              Wer hat, dem wird noch mehr gegeben
            </p>
            <p className='graphicDescription mobile only'>
              Einkommensentwicklung in der Schweiz in Fr. zwischen 1996 und 2016
            </p>

            <p className='graphicDescription mobile only'>
              <b>Wenigverdiener:</b> 25%-Perzentil <br />
              (ein Viertel verdient weniger, drei Viertel mehr)
              <br />
              <b>Mittelverdiener:</b> 50%-Perzentil = Median <br />
              (die eine Hälfte verdient mehr, die andere weniger)
              <br />
              <b>Gutverdiener:</b> 90%-Perzentil <br />
              (10% verdienen mehr, 90% weniger)
              <br />
              <b>Sehrgutverdiener:</b> 99%-Perzentil <br />
              (1% verdient mehr, 99% weniger)
              <br />
              <b>Spitzenverdiener:</b> 99,9%-Perzentil <br />
              (0,1% verdient mehr, 99,9% weniger)
            </p>
          </div>

          <div
            className='ui container entwicklung mobile hidden'
            style={{ marginBottom: '1rem' }}
          >
            <div className='ui text container' style={{ marginBottom: '1rem' }}>
              <div className='textWrapper'>
                <p style={{ marginBottom: '2rem' }}>
                  Frappant ist die Entwicklung der verschiedenen
                  Einkommensklassen, die zunehmend auseinanderklaffen. So konnte
                  das bestverdienende Tausendstel innert zwanzig Jahren um
                  53&nbsp;Prozent zulegen – von mindestens 690&nbsp;000 auf
                  mindestens 1,05 Millionen Franken. Im Kanton Schwyz haben sich
                  diese Einkommen gar mehr als verdreifacht (auf mehr als 3,4
                  Millionen Franken).
                </p>

                <div className='boxWrapper'>
                  <p>
                    Einkommensentwicklung in der Schweiz in Fr. zwischen 1996
                    und 2016
                  </p>
                  <p style={{ width: '581px' }}>
                    <b>Wenigverdiener:</b> 25%-Perzentil (ein Viertel verdient
                    weniger, drei Viertel mehr)
                    <br />
                    <b>Mittelverdiener:</b> 50%-Perzentil = Median (die eine
                    Hälfte verdient mehr, die andere weniger)
                    <br />
                    <b>Gutverdiener:</b> 90%-Perzentil (10% verdienen mehr, 90%
                    weniger)
                    <br />
                    <b>Sehrgutverdiener:</b> 99%-Perzentil (1% verdient mehr,
                    99% weniger)
                    <br />
                    <b>Spitzenverdiener:</b> 99,9%-Perzentil (0,1% verdient
                    mehr, 99,9% weniger)
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className='ui container'>
            <div className='graphicByline mobile hidden'>
              Quelle: Eidgenössische Steuerverwaltung
            </div>
          </div>

          <div
            className='ui container entwicklung mobile only'
            style={{ marginBottom: '1rem' }}
          >
            <div className='ui text container' style={{ marginBottom: '1rem' }}>
              <div className='textWrapper' />
            </div>
          </div>
          <div className='ui container'>
            <div className='graphicByline mobile only'>
              Quelle: Eidgenössische Steuerverwaltung
            </div>
          </div>

          <Waypoint
            scrollableAncestor={window}
            onEnter={event => {
              if (event.previousPosition === Waypoint.below) {
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                  event: 'Interactions',
                  // eslint-disable-next-line
                  event_action: 'vertical-scroll',
                  // eslint-disable-next-line
                  event_label: '75ContentRead'
                })
              }
            }}
          />

          <div className='ui text container'>
            <p>
              Ganz anders sieht es beim ärmsten Viertel aus. Dessen steuerbare
              Einkommen stiegen gesamtschweizerisch nur um 5 Prozent – von
              maximal 21&nbsp;000 auf maximal 22&nbsp;000 Franken. Damit konnten
              die Wenigverdiener nicht einmal mit der Teuerung mithalten, die
              sich in dieser Zeitspanne auf rund 10 Prozent belief. Zu beachten
              ist freilich auch, dass sich die steuerlichen Abzüge zwischen 1996
              und 2016 änderten – etwa für Kinder. Dies reduziert die
              steuerbaren Einkommen.
            </p>
            <p>
              Am ungleichsten sind die Einkommen – wenig überraschend – in
              Vaux-sur-Morges verteilt. Dies lässt sich mit dem sogenannten
              Gini-Koeffizienten beziffern – einer Zahl zwischen 0 und 1. Je
              höher der Wert, desto stärker die Ungleichheit. Bei 1 verdient
              einer alles und die anderen nichts, bei 0 verdienen alle gleich
              viel. In Vaux-sur-Morges beträgt der Gini-Koeffizient 0,94. Unter
              den grösseren Gemeinden ist er in Freienbach mit 0,68 am höchsten,
              am tiefsten in Emmen mit 0,38.
            </p>
            <p>
              Im internationalen Vergleich sind die Einkommensunterschiede in
              der Schweiz relativ moderat. Wobei zu beachten ist, dass die
              Kapitalgewinne hierzulande steuerfrei sind und deshalb von den
              Steuerstatistiken nicht erfasst werden.
            </p>
          </div>

          <div className='ui container'>
            <div className='iframeContainer'>
              <AutofitIFrame
                title='Boomende Innerschweiz, zaghafte Ostschweiz'
                aria-label='interactive map'
                src='//datawrapper.dwcdn.net/Xc3ZO/5/'
                height={this.isTable ? (this.isMobile ? '440' : '540') : '640'}
                width='600'
              />
            </div>
          </div>
          <div className='ui text container'>
            <p>
              Unter den Kantonen weist Genf die grössten Einkommensdifferenzen
              auf. Am gleichmässigsten ist der Verdienst im Kanton Uri verteilt.
              Dort stieg zwischen 1996 und 2016 auch der Median am stärksten –
              um 34 Prozent. Beim Einkommensschnitt hingegen schwingt Schwyz mit
              einem Plus von 79 Prozent oben aus, während Schaffhausen – auch
              hier – die Rolle des Schlusslichts zufällt.
            </p>
            <p className='kursiv'>
              Einen Überblick über die Einkommen in sämtlichen Gemeinden finden
              Sie <a href='//datawrapper.dwcdn.net/CkZpw/7/'>hier</a>.
            </p>
          </div>
          {/* <div className='ui container'>
            <div className='iframeContainer'>
              <AutofitIFrame
                title='Durchschnittliches steuerbares Einkommen nach Gemeinde, 2016'
                aria-label='interactive map'
                src='//datawrapper.dwcdn.net/CkZpw/7/'
                height={this.isTable ? (this.isMobile ? '440' : '540') : '640'}
                width='600'
              />
            </div>
          </div> */}
        </div>

        {/* TODO Add your credits in this component */}
        <Footer
          articleId={ARTICLE_ID}
          additionalShares={ADDITIONAL_SHARES}
          credits={[
            ['Text und Analyse', 'Iwan Städler'],
            ['Digitale Umsetzung und Grafiken', 'Patrick Vögeli'],
            ['Quelle', 'Eidgenössische Steuerverwaltung']
          ]}
          questions={['Wie informativ war der Beitrag?']}
        />
      </div>
    )
  }
}
